import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import app from 'flarum/forum/app';

import PointsRanking from './components/PointsRanking';
import LinkButton from 'flarum/common/components/LinkButton';

export default function () {
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user!;
    const isActor = app.session.user === user;

    items.add(
      'pointDetails',
      <LinkButton href={app.route('user.pointDetails', { username: user.slug() })} icon="fas fa-gift">
        积分明细
      </LinkButton>,
      -1
    );
  });
}
